import React, { useContext, useState } from "react";
import axios from "axios";
import { Alert, Button, Col, Form, Row, Card } from "react-bootstrap";
import { FiLock, FiRefreshCw, FiSave } from "react-icons/fi";
import AuthContext from "../context/AuthContext";

const API_URL = process.env.REACT_APP_API_URL;

const initialForm = {
  currentPassword: "",
  newPassword: "",
  confirmPassword: "",
};

const ChangePassword = () => {
  const { user } = useContext(AuthContext);
  const [form, setForm] = useState(initialForm);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [saving, setSaving] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setSuccess("");

    if (form.newPassword !== form.confirmPassword) {
      setError("Mật khẩu mới và xác nhận mật khẩu không khớp.");
      return;
    }

    setSaving(true);

    try {
      const response = await axios.put(`${API_URL}/auth/change-password`, form);
      setSuccess(response.data?.message || "Đổi mật khẩu thành công.");
      setForm(initialForm);
    } catch (err) {
      setError(err.response?.data || "Đã xảy ra lỗi khi đổi mật khẩu.");
    } finally {
      setSaving(false);
    }
  };

  const handleReset = () => {
    setForm(initialForm);
    setError("");
    setSuccess("");
  };

  return (
    <Row className="justify-content-center">
      <Col xs={12} lg={7} xl={6}>
        <Card>
          <Card.Body>
            <div className="d-flex align-items-start justify-content-between gap-3 mb-4">
              <div>
                <h2 className="mb-2">Đổi mật khẩu</h2>
                <p className="text-muted mb-0">
                  Đổi mật khẩu cho tài khoản {user?.username || user?.display_name || "hiện tại"}.
                </p>
              </div>
              <div className="admin-stat-icon">
                <FiLock />
              </div>
            </div>

            {error && (
              <Alert variant="danger" onClose={() => setError("")} dismissible>
                {error}
              </Alert>
            )}
            {success && (
              <Alert variant="success" onClose={() => setSuccess("")} dismissible>
                {success}
              </Alert>
            )}

            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>Mật khẩu hiện tại</Form.Label>
                <Form.Control
                  type="password"
                  name="currentPassword"
                  value={form.currentPassword}
                  onChange={handleChange}
                  autoComplete="current-password"
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Mật khẩu mới</Form.Label>
                <Form.Control
                  type="password"
                  name="newPassword"
                  value={form.newPassword}
                  onChange={handleChange}
                  autoComplete="new-password"
                  required
                />
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label>Xác nhận mật khẩu mới</Form.Label>
                <Form.Control
                  type="password"
                  name="confirmPassword"
                  value={form.confirmPassword}
                  onChange={handleChange}
                  autoComplete="new-password"
                  required
                />
              </Form.Group>

              <div className="d-flex flex-wrap gap-2 justify-content-end">
                <Button
                  type="button"
                  variant="outline-secondary"
                  onClick={handleReset}
                  disabled={saving}
                >
                  <FiRefreshCw className="me-2" />
                  Làm mới
                </Button>
                <Button type="submit" variant="primary" disabled={saving}>
                  <FiSave className="me-2" />
                  {saving ? "Đang lưu..." : "Lưu mật khẩu"}
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default ChangePassword;
